module.exports = __webpack_public_path__ + "static/company-logo-og-81e25d0dcee150a304f1f2db4e2d99e3.jpg";